<template>
  <div role="list" class="tv tv-list tv-list-ruled" data-turbolinks="false">
    <padlet-listitem
      v-for="wall in sortedAndFilteredWalls"
      :key="wall.id"
      :wall="wall"
      role="listitem"
      :actions="actions"
      @click.native="onClick($event, wall)"
    />
  </div>
</template>
<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import PadletListitem from './padlet_listitem'
const dateSort = (a, b) => {
  if ((a.updated_at || a.updatedAt) > (b.updated_at || b.updatedAt)) {
    return -1
  }
  if ((a.updated_at || a.updatedAt) === (b.updated_at || b.updatedAt)) {
    return 0
  }
  return 1
}
const nameSort = (a, b) => {
  return a.title.localeCompare(b.title)
}
export default {
  components: { PadletListitem },
  props: {
    walls: { type: Array, default: () => [] },
    sortBy: { type: String, default: 'date' },
    filter: { type: Function, default: null },
    navigate: { type: Boolean, default: true },
    actions: { type: Boolean, default: false },
  },
  computed: {
    sortedAndFilteredWalls() {
      let wallFilter = this.filter
      if (!wallFilter) {
        wallFilter = (a) => a
      }
      if (this.sortBy == 'date') {
        return this.walls.slice().filter(wallFilter).sort(dateSort)
      }

      return this.walls.slice().filter(wallFilter).sort(nameSort)
    },
  },
  methods: {
    onClick(e, wall) {
      if (!this.navigate) {
        e.preventDefault()
        this.$emit('select', wall)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tv-list {
  background-color: white;
}
</style>
